export const dictionary = {
  en: {
    add: "Add",
    actions: "Actions",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    start: "Start",
    end: "End",
    all: "all"
  },
  it: {
    add: "Aggiungi",
    actions: "Azioni",
    selectAll: "Seleziona tutti",
    deselectAll: "Deseleziona tutti",
    start: "Inizio",
    end: "Fine",
    all: "tutti"

  },
};
